import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propFunc, } from '../../../../../../../helpers/custom-prop-types';
const SlideSearchHeaderSideMenuSpLogout = (props) => {
    const { className, onClickLogout } = props;
    return (_jsx("div", Object.assign({ className: clsx('slide_search_header_side_menu_sp_logout', className) }, { children: _jsx("button", Object.assign({ className: 'logout_text link-text', onClick: onClickLogout, type: 'button' }, { children: "\u30ED\u30B0\u30A2\u30A6\u30C8" })) })));
};
SlideSearchHeaderSideMenuSpLogout.propTypes = {
    className: propStr(),
    onClickLogout: propFunc().isRequired,
};
SlideSearchHeaderSideMenuSpLogout.defaultProps = {
    className: '',
};
export default SlideSearchHeaderSideMenuSpLogout;
